import { useEffect, type FC } from "react";
import { useLocation } from "react-router-dom";
import type { TitleProps } from "./TitleProps";

const titles: Record<string, string> = {
  "/": "LotCamp | Sleep at the show.",
  "/fests": "Fests | LotCamp",
  "/calendar": "Calendar | LotCamp",
  "/about": "About | LotCamp",
  "/contact": "Contact | LotCamp",
};

const Title: FC<TitleProps> = ({ title }) => {
  const location = useLocation();

  useEffect(() => {
    if (title) {
      document.title = title;
      return;
    }

    document.title =
      titles[location.pathname] ?? "LotCamp | Sleep at the show.";
  }, [location, title]);

  return null;
};

export default Title;
